import aa from 'search-insights';
import { getCustomerId } from '../utils';

/** search-insights' cookie, holding the anonymous user token */
const ALGOLIA_COOKIE = '_ALGOLIA';

const customerId = getCustomerId();

const hasAnalyticsConsent = () => window.Termly?.getConsentState().analytics === true;

/**
 * Algolia Insights doesn't understand Google Consent Mode, so we gate it on Termly's analytics
 * consent ourselves: nothing is sent without it.
 *
 * With consent, useCookie persists the anonymous user token in the _ALGOLIA cookie. Without it,
 * search-insights makes a new in-memory token on every page load, so a guest's search on one
 * page and their add-to-cart on the next look like two different users.
 * Logged-in customers are identified by authenticatedUserToken either way.
 */
function initInsights(consentGiven: boolean) {
  aa('init', {
    appId: ALGOLIA_INFO.APP_ID,
    apiKey: ALGOLIA_INFO.SEARCH_KEY,
    userHasOptedOut: !consentGiven,
    // https://www.algolia.com/doc/libraries/search-insights/init#param-use-cookie
    useCookie: consentGiven,
    // https://www.algolia.com/doc/libraries/search-insights/init#param-authenticated-user-token
    authenticatedUserToken: customerId ? `customer-${customerId}` : undefined,
  });
}

let consentGiven = hasAnalyticsConsent();
console.debug('Algolia Insights consent given:', consentGiven);
initInsights(consentGiven);

/**
 * Follow consent changes without waiting for the next page load. Termly also fires this on
 * page load, hence the no-op when nothing changed.
 * Re-initializing keeps the current in-memory token, and saves it to the cookie once consent is given.
 */
window.Termly?.on('consent', () => {
  const nowGiven = hasAnalyticsConsent();
  if (nowGiven === consentGiven) {
    return;
  }

  consentGiven = nowGiven;
  initInsights(consentGiven);

  if (!consentGiven) {
    // search-insights never removes its own cookie, so clear it when consent is withdrawn
    document.cookie = `${ALGOLIA_COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }
});

export default aa;
